import { OfferSource } from '@cds';
import { Competition, Region } from '@cds/betting-offer/tags';
import { EventParticipant, EventParticipantImage } from '@frontend/sports/betting-offer/feature/model';
import { CountItem } from '@frontend/sports/common/core/data-access/sport-model';
import { getReverseEnum } from '@frontend/sports/common/core/utils/extended-types';
import { FavouritesSport } from '@frontend/sports/favourites/core/feature';
import { LeagueGroup } from '@frontend/sports/grid/core/feature/model';
import { ObservableGrid } from '@frontend/sports/grid/core/feature/observables';
import { ParticipantDetail } from '@frontend/sports/types/components/team-pages';
import { TabBarItem } from '@frontend/sports/web/tab-bar-utils';

import { Tile } from '../shared-models/tile.model';

export interface TeamPagesDetailsModel {
    teampagesGridViewModel: TeamPagesGridViewModel;
    bannerViewModel: BannerViewModel;
    marqueeTiles: Tile[];
    sportCounts: CountItem;
}
export interface TeamPagesNavigationViewModel {
    teams: Team[];
    competitionTabs: TabBarItem<string>[];
    currentSport: FavouritesSport;
    selectedTeam: Team;
    hasFavouritedTeams: boolean;
    popularTeams: ParticipantDetail[];
}
export interface TeamPagesViewModel {
    teamPagesDetailsModel: TeamPagesDetailsModel;
    teamPagesNavigationViewModel: TeamPagesNavigationViewModel;
}

export interface Team {
    name: string;
    id: number;
    participantImage?: EventParticipantImage;
    sportIcon?: string;
    isFavourited: boolean;
    isSelected: boolean;
    sport?: FavouritesSport;
    favouriteParticipant?: EventParticipant;
    offerSource?: OfferSource;
    competitionId?: string;
    teamType?: FavouriteType;
}

export enum FavouriteType {
    League = 'L',
    Participant = 'P',
    ParticipantV2 = 'P2',
    Fixture = 'F',
    FixtureV2 = 'F2',
}

export enum FixtureView {
    Grid,
    GridList,
    Standings,
}

export enum FixtureTab {
    Matches = 1,
    Outrights = 2,
    Standings = 3,
    Specials = 4,
}

export const ReverseFixtureTab = getReverseEnum(FixtureTab);

export interface BannerViewModel {
    team: Team;
    backgroundImage: string;
}

export enum TeamMenuItem {
    Showmore = '9999',
    MyTeams = '0',
}
export interface TeamPageCompetition {
    id: string;
    name: string;
    sportId: number;
}

export interface TeamPagesGridModel {
    tabs: TabBarItem[];
    gridModel?: ObservableGrid;
    view?: FixtureView;
    standings?: CountItem;
    currentStandingsGroups?: LeagueGroup[];
    currentStandingsSport?: CountItem;
    currentStandings?: CountItem;
    groups?: LeagueGroup[];
    noMarketsForTeam?: boolean;
    loading?: boolean;
    fixtureIds?: string[];
}

export interface TeamPagesGridViewModel {
    teamPagesGridModel: TeamPagesGridModel;
    selectedTeam: Team;
}

export interface MasterDataResponse {
    competition: Competition;
    region: Region;
}
